import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import styles from "../ModernDashboard.module.css";

/**
 * Fintech-style quick action grid (Deposit, Withdraw, Bills, More).
 */
export default function QuickActions({ onDepositClick, onWithdrawalClick }) {
  return (
    <div className={styles.mdQuickSection}>
      <h3 className={styles.mdQuickTitle}>Quick Actions</h3>
      <div className={styles.mdQuickGrid}>
        {/* Deposit */}
        <div className={styles.mdQuickItem} onClick={onDepositClick}>
          <div className={`${styles.mdQuickIcon} ${styles.mdQuickIconDeposit}`}>
            💰
          </div>
          <span className={styles.mdQuickLabel}>Deposit</span>
        </div>

        {/* Withdraw */}
        <div className={styles.mdQuickItem} onClick={onWithdrawalClick}>
          <div
            className={`${styles.mdQuickIcon} ${styles.mdQuickIconWithdraw}`}
          >
            💸
          </div>
          <span className={styles.mdQuickLabel}>Withdraw</span>
        </div>

        {/* Bills */}
        <Link to="/user/tables" className={styles.mdQuickItem}>
          <div className={`${styles.mdQuickIcon} ${styles.mdQuickIconBills}`}>
            📋
          </div>
          <span className={styles.mdQuickLabel}>Bills</span>
        </Link>

        {/* More */}
        <Link to="/user/user-page#about" className={styles.mdQuickItem}>
          <div className={`${styles.mdQuickIcon} ${styles.mdQuickIconMore}`}>
            ⚡
          </div>
          <span className={styles.mdQuickLabel}>More</span>
        </Link>
      </div>
    </div>
  );
}

QuickActions.propTypes = {
  onDepositClick: PropTypes.func.isRequired,
  onWithdrawalClick: PropTypes.func.isRequired,
};